export default "__VITE_ASSET__CFzVwSzU__"